import React from 'react'

const TypeButton = ({ children, type, selected, onClick, icon = null }) => {
  const Icon = icon
  return (
    <button
      type="button"
      className={`${
        selected
          ? 'border-2 border-indigo-600 bg-indigo-600 text-white shadow-md'
          : 'border-2 border-gray-200 bg-white text-gray-600 hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50'
      } flex gap-2 px-4 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 ease-in-out items-center`}
      onClick={() => onClick(type)}
    >
      <Icon
        className="h-5 w-5"
        stroke={`${selected ? 'white' : 'currentColor'}`}
        fill={`${selected ? 'white' : 'none'}`}
      />
      {children}
    </button>
  )
}

export default TypeButton
